import createStore from '@/stores/createStore';
import useGlobalConfigs from '@/stores/globalConfigs';

interface IStateCreateEmr {
  isFormChange: boolean;
  emrType?: IEMRType;
  setEmrType: (val: string) => void;
  reset: () => void;
  setIsFormChange: (_: boolean) => void;
}

const initValues = { emrType: undefined, isFormChange: false };

const useCreateEmr = createStore<IStateCreateEmr>((set) => ({
  ...initValues,
  setEmrType(val: string) {
    set((s) => ({ ...s, emrType: useGlobalConfigs.getState().emrTypes?.[val] }));
  },
  setIsFormChange(val: boolean) {
    set((s) => ({ ...s, isFormChange: val }));
  },
  reset() {
    set((s) => ({ ...s, ...initValues }));
  },
}));

export default useCreateEmr;
